__turbopack_context__.v({
  "Popup": "index-module__DwXQxW__Popup",
  "Positioner": "index-module__DwXQxW__Positioner",
  "Trigger": "index-module__DwXQxW__Trigger",
});
